import { render, staticRenderFns } from "./setting-page.vue?vue&type=template&id=3348ec34&"
import script from "./setting-page.vue?vue&type=script&lang=js&"
export * from "./setting-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports